export const REGANTO_DEZINER_REQUEST = "REGANTO_DEZINER_REQUEST";
export const REGANTO_DEZINER_SUCCESS = "REGANTO_DEZINER_SUCCESS";
export const REGANTO_DEZINER_FAILED = "REGANTO_DEZINER_FAILED";
